<!-- @format -->

<template>
	<el-form ref="formRef" :model="formFormDatas" scroll-to-error>
		<Form
			v-model="formFormDatas"
			:widget-datas="widgetDatas"
			:disabled="disabled"
			class="preview-content"
			:show-label-icon="true"
			@field-change="(...args) => emit('fieldChange', ...args)"
		/>
	</el-form>
</template>

<script setup lang="ts">
	import Form from '../components/Form/index.vue';
	import type { FormInstance } from 'element-plus';

	interface Props {
		widgetDatas: any[];
		formDatas?: any;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		disabled: false,
		defaultDatas: {},
	});

	const emit = defineEmits(['update:formDatas', 'fieldChange']);

	const formFormDatas = computed({
		get() {
			return props.formDatas || {};
		},
		set(value) {
			emit('update:formDatas', value);
		},
	});

	const formRef = ref<FormInstance>();

	const setFieldsValue = (fields) => {
		formFormDatas.value = { ...formFormDatas.value, ...fields };
	};

	provide('setFieldsValue', setFieldsValue);
	provide('widgetDatas', props.widgetDatas);
	provide('formDatas', formFormDatas);

	defineExpose({ formRef });
</script>

<style scoped lang="scss">
	.preview-content {
		height: 100%;
		align-content: flex-start;

		:deep(.form-item) {
			.el-form-item__label {
				font-size: 12px !important;
				display: inline-block;
				text-align: end;
				width: 120px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
</style>
